// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { sparseProjectSchema } from '@/sparse/api/types';
import { z } from 'zod';

const PATH = '/v1/sparse/project';

const responseSchema = z
  .object({
    data: z.array(sparseProjectSchema).nullable(),
    metadata: responseMetadataSchema,
  })
  .transform(({ data, ...response }) => ({
    ...response,
    projects: data ?? [],
  }));

/**
 * Requests all sparse projects from the remote API.
 * This endpoint returns a lightweight list of all projects without filtering options.
 */
export async function getSparseProjects() {
  const response = await api.get(PATH);
  const result = await parseResponse(responseSchema, response.data, {
    schemaName: 'SparseProjects',
    endpoint: PATH,
  });
  return result;
}
